
import classNames from "classnames";
import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Offcanvas, OffcanvasHeader, OffcanvasBody, Button, Nav, NavLink, NavItem } from "reactstrap";

import {
  Card,
  CardBody,
  CardTitle,
  CardText,
  Badge,
  Row,
  Col,
} from "reactstrap";
import LogsDataTable from "./LogsDataTable";
import * as url from "../../../../helpers/url_helper";
import UserAction from "./UserAction";
import { convertLocalDate } from "../../../../Utils/configController";
import { ToastContainer } from "react-toastify";
import SessionDataTable from "./SessionDataTable";


interface SettingsProps {
  mobileGrid: number;
  tabGrid: number;
  isSearchBar: boolean;
  noOfDeviceLimit: number;
  userId: any;
}


function UserSettingModal({ mobileGrid, tabGrid, isSearchBar, noOfDeviceLimit, userId }: SettingsProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Logs");

  const handleTabChange = (key: any) => {
    setActiveTab(key);
  }

  const [loading, setLoading] = useState<boolean>(false);
  const [isOpneRequestModel, setOpenRequestModel] = useState<boolean>(false);
  const [requestData, setRequestData] = useState<any>({});
  const [isOpenResponseModel, setOpenResponseModel] = useState<boolean>(false);
  const [responseData, setResponseData] = useState<any>(null);


  const handleViewRequest = (rowData: any) => {
    setOpenRequestModel(true);
    setRequestData(rowData.request);
  };

  const handleViewResponse = (rowData: any) => {
    setOpenResponseModel(true);
    setResponseData(rowData.response);
  };


  const toggleRequestModel = () => {
    setOpenRequestModel(!isOpneRequestModel);
  };

  const toggleResponsetModel = () => {
    setOpenResponseModel(!isOpenResponseModel);
  };

  const toggleSettingsModal = () => {
    setIsModalOpen(prev => !prev);
  };


  const Logcolumns = [
    {
      name: "Created",
      selector: (row: any) => row?.createdAt || "",
      cell: (row: any) => (
        <div>{row?.createdAt ? convertLocalDate(row.createdAt) : "-"}</div>
      ),
      sortable: true,
      grow: 2,
      wrap: true,
    },
    {
      name: "Method",
      selector: (row: any) => row?.method || "",
      cell: (row: any) => <div>{row?.method || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },
    {
      name: "IP Address",
      selector: (row: any) => row?.ipAddress || "",
      cell: (row: any) => <div>{row?.ipAddress || "-"}</div>,
      sortable: true,
      grow: 1,
      wrap: true,
    },
    {
      name: "Request",
      cell: (row: any) => (
        <button
          style={{ border: "none", outline: "none", background: "none" }}
          onClick={() => handleViewRequest(row)}
        >
          <span
            className="badge bg-primary"
            style={{
              height: "25px",
              width: "60px",
              fontSize: "12px",
              padding: "6px",
            }}
          >
            View
          </span>
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      grow: 0.8,
    },
    {
      name: "Response",
      cell: (row: any) => (
        <button
          style={{ border: "none", outline: "none", background: "none" }}
          onClick={() => handleViewResponse(row)}
        >
          <span
            className="badge bg-primary"
            style={{
              height: "25px",
              width: "60px",
              fontSize: "12px",
              padding: "6px",
            }}
          >
            View
          </span>
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      grow: 0.8,
    },
    {
      name: "OS Name",
      selector: (row: any) => row?.createdUserDeviceId?.osName || "",
      cell: (row: any) => <div>{row?.createdUserDeviceId?.osName || "-"}</div>,
      sortable: true,
      grow: 1,
      wrap: true,
    },
    {
      name: "OS Version",
      selector: (row: any) => row?.createdUserDeviceId?.osVersion || "",
      cell: (row: any) => (
        <div>{row?.createdUserDeviceId?.osVersion || "-"}</div>
      ),
      sortable: true,
      grow: 1,
      wrap: true,
    },
    {
      name: "Device Info",
      selector: (row: any) => row?.createdUserDeviceId?.deviceInfo || "",
      cell: (row: any) => (
        <div>{row?.createdUserDeviceId?.deviceInfo || "-"}</div>
      ),
      sortable: true,
      grow: 1,
      wrap: true,
    },
  ];


  const Sessioncolumns = [

    {
      name: "Date",
      selector: (row: any) => row.date || "-",
      cell: (row: any) => <div>{row?.date || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },

    {
      name: "Sessions",
      selector: (row: any) => row.totalSessions || "-",
      cell: (row: any) => <div>{row?.totalSessions || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },

    {
      name: "Operated",
      selector: (row: any) => row.totalOperatedSessions || "-",
      cell: (row: any) => <div>{row?.totalOperatedSessions || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },

    {
      name: "Not Operated",
      selector: (row: any) => row.totalNotOperatedSessions || "-",
      cell: (row: any) => <div>{row?.totalNotOperatedSessions || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },


    {
      name: "Operations",
      selector: (row: any) => row.totalOperations || "-",
      cell: (row: any) => <div>{row?.totalOperations || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },

    {
      name: "Switch(ON/OFF)",
      selector: (row: any) => row.totalSwitchOperations || "-",
      cell: (row: any) => <div>{row?.totalSwitchOperations || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },


    {
      name: "Scene",
      selector: (row: any) => row.totalSceneOperations || "-",
      cell: (row: any) => <div>{row?.totalSceneOperations || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },



    {
      name: "Remote",
      selector: (row: any) => row.totalRemoteOperations || "-",
      cell: (row: any) => <div>{row?.totalRemoteOperations || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },




    {
      name: "Total Online",
      selector: (row: any) => row.totalOnlineTimeStr || "-",
      cell: (row: any) => <div>{row?.totalOnlineTimeStr || "-"} ({row?.totalOnlineTime || "-"}s) </div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },

  ]


  return (
    <div>
      <i
        className="bx bx-cog cursor-pointer"
        style={{ fontSize: "22px" }}
        title="Settings"
        onClick={() => setIsModalOpen(true)}
      >

      </i>

      <Offcanvas
        isOpen={isModalOpen}
        toggle={toggleSettingsModal}
        direction="end"
        style={{ width: "95%" }}
        className="border-start "
      >
        <OffcanvasHeader
          toggle={toggleSettingsModal}
          className="d-flex align-items-center justify-content-between  "

        >
          <h5
            className="modal-title "
            id="staticBackdropLabel"
            style={{
              textAlign: "center",
              fontWeight: 800,

            }}
          >
            Settings
          </h5>

        </OffcanvasHeader>
        <OffcanvasBody style={{
          backgroundColor: "#f7f7fa",

        }}>


          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <Nav
                className="rounded-pills "
                style={{
                  backgroundColor: "#F1F1F1",
                  // width: "100%",
                  borderRadius: 10,
                  marginBottom: "10px",
                }}
              >
                <div className="d-flex">
                  {["Logs", "Session"].map((key) => (
                    <NavItem key={key}>
                      <NavLink
                        onClick={() => handleTabChange(key)}
                        className={classNames({ active: activeTab === key })}
                        style={{
                          cursor: "pointer",
                          backgroundColor:
                            activeTab === key ? "#343a40" : "#F1F1F1",
                          fontWeight: activeTab === key ? 500 : 300,
                          borderRadius: 10,
                          fontSize: 16,
                          color: activeTab === key ? "#ffffff" : "#000000",
                        }}
                      >
                        {key}
                      </NavLink>
                    </NavItem>
                  ))}
                </div>


              </Nav>
              <div className="d-flex align-items-center justify-content-end w-100 gap-3"
              
              >
                <div>
                  <span className="me-1">MobileGrid:</span>
                  <span className="fw-bold">{mobileGrid}</span>
                </div>

                <div>
                  <span className="me-1">TabGrid:</span>
                  <span className="fw-bold">{tabGrid}</span>
                </div>

                <div>
                  <span className="me-1">SearchBar:</span>
                  <span className="fw-bold">
                    {isSearchBar ? "true" : "false"}
                  </span>
                </div>

                <div>
                  <span className="me-1">Device Limit:</span>
                  <span className="fw-bold">{noOfDeviceLimit}</span>
                </div>
              </div>
            </div>
            <div>
              <ToastContainer />
              {/* VIEW REQUEST MODEL */}
              <Modal
                isOpen={isOpneRequestModel}
                role="dialog"
                autoFocus={true}
                centered={true}
                className="exampleModal"
                // tabIndex="-1"
                toggle={toggleRequestModel}
              >
                <div className="modal-content">
                  <ModalHeader style={{ justifyContent: "center" }}>
                    {"Request"}
                  </ModalHeader>
                  <ModalBody>
                    {/* {requestData} */}
                    <pre style={{ whiteSpace: "pre-wrap" }}>
                      {JSON.stringify(requestData, null, 2)}
                    </pre>
                  </ModalBody>
                  <ModalFooter style={{ justifyContent: "center" }}>
                    <button
                      className="btn btn-dark"
                      type="submit"
                      onClick={() => setOpenRequestModel(false)}
                    >
                      Ok
                    </button>
                  </ModalFooter>
                </div>
              </Modal>

              {/* VIEW RESPONSE MODEL */}
              <Modal
                isOpen={isOpenResponseModel}
                role="dialog"
                autoFocus={true}
                centered={true}
                className="exampleModal"
                // tabIndex="-1"
                toggle={toggleResponsetModel}
              >
                <div className="modal-content">
                  <ModalHeader style={{ justifyContent: "center" }}>
                    {"Response"}
                  </ModalHeader>
                  <ModalBody>
                    {/* {responseData} */}
                    <pre style={{ whiteSpace: "pre-wrap" }}>
                      {JSON.stringify(responseData, null, 2)}
                    </pre>
                  </ModalBody>
                  <ModalFooter style={{ justifyContent: "center" }}>
                    <button
                      className="btn btn-dark"
                      type="submit"
                      onClick={() => setOpenResponseModel(false)}
                    >
                      Ok
                    </button>
                  </ModalFooter>
                </div>
              </Modal>


              {activeTab === "Logs" && (
                <LogsDataTable
                  apiURL={`${url.BASE_URL}${url.GET_USER_ACTION_LIST}`}
                  title="Logs"
                  columns={Logcolumns}
                  loading={loading}
                  setLoading={setLoading}
                  userId={userId}
                />
              )}



              {activeTab === "Session" && (
                <SessionDataTable
                  apiURL={`${url.BASE_URL}${url.GET_USER_SESSION_LIST}`}
                  title="Session"
                  columns={Sessioncolumns}
                  loading={loading}
                  setLoading={setLoading}
                  userId={userId}
                />
              )}
            </div>

          </Col>


        </OffcanvasBody>
        <div
          className="d-flex justify-content-end border-top"
          style={{ gap: 8, padding: "12px 16px" }}
        >
          <Button color="btn btn-dark" onClick={toggleSettingsModal} size="sm">
            Cancel
          </Button>

        </div>
      </Offcanvas>
    </div >
  );
}

export default UserSettingModal;





